export default class SaveShortCutListener {

    constructor(callback) {
        this.callback = callback;

        document.addEventListener('keydown', this.eventListener = event => {
            this.save(event)
        });
    }


    save(event) {
        if(this.modifierPressed(event) && event.code === 'KeyS') {
            this.callback();
            event.preventDefault();
        }
    }

    modifierPressed(event) {
        return window.navigator.platform.match("Mac") ? event.metaKey : event.ctrlKey
    }


    removeEventListener() {
        document.removeEventListener('keydown', this.eventListener);
    }
}